import React from "react";

const HowToUse = () => {
  return (
    <div className="w-full pl-80 pr-60 items-center">
      <h1 className="text-3xl font-bold mb-4 text-center pb-6 shadow-md rounded-lg">
        How to Use Real-Time Notifier
      </h1>
      <h2 className="text-2xl font-semibold mb-2">Installation</h2>
      <pre className="bg-gray-800 text-white px-8 py-4 shadow-lg rounded-md">
        <code>npm install real-time-notifier</code>
      </pre>
      <h2 className="text-2xl font-semibold mt-4 mb-2">Usage</h2>
      <pre className="bg-gray-700 text-white p-8 shadow-lg rounded-md">
        <code>
          {`const express = require('express');
const http = require('http');
const socketIo = require('socket.io');

const app = express();
const server = http.createServer(app);
const io = socketIo(server);

io.on('connection', (socket) => {
    console.log('a user connected');
    socket.on('disconnect', () => {
        console.log('user disconnected');
    });
});

const PORT = process.env.PORT || 3000;
server.listen(PORT, () => {
    console.log(\`listening on *:\${PORT}\`);
});`}
        </code>
      </pre>
    </div>
  );
};

export default HowToUse;
